import {
  IconButton,
  InputAdornment,
  Menu,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useContext, useEffect, useRef, useState } from "react";
import { font } from "../../styles/font";
import { theme } from "../../styles/theme";
import { stringToArray } from "../../utility/string";

import { ButtonCustom } from "../../components/button";
import {
  CheckboxMA,
  TextFieldMA,
  TooltipMA,
  VisuallyHiddenInput,
} from "../../styles/styledComponents";
import { RegisteredUsers } from "../../components/userOnBoarding/registeredUsers";
import { RevokedUsers } from "../../components/userOnBoarding/revokedUsers";
import { HttpStatusCode } from "axios";
import {
  getAudit,
  getLicencBatch,
  uploadCVS,
} from "../../api/controllers/dashboardController";
import { GlobalSnackBar } from "../../components/snackBar";
import {
  getUploadCVS,
  revokeMultipleUser,
  unRevokeMultipleUser,
} from "../../api/controllers/registeredUserController";
import { useLocation, useNavigate } from "react-router-dom";
import { ApplicationContext } from "../../context/application_ctx";
import { Search } from "@mui/icons-material";
import RegisterEmployeeDialog from "../../components/dialog/registerEmployeeDialog";
import UpdateEmployeeDialog from "../../components/dialog/updateEmployeeDialog";
import { grey } from "@mui/material/colors";
import DeleteEmployeeDialog from "../../components/dialog/deleteEmployeeDialog";
import UploadEmployeeDialog from "../../components/dialog/uploadEmployeeDialog";
import OrganisationBadge from "../../components/statusBadge/organisationBadge";
import { IconBack } from "../../svgIcons/icons";
import RevokeConfirmation from "../../components/dialog/revokeConfirmation";
import Papa from "papaparse";
import UploadConfirmation, {
  UploadProgress,
} from "../../components/dialog/confirmUploadDialog";
import dayjs from "dayjs";
import { TableVirtuoso } from "react-virtuoso";
import { inviteEmployee } from "../../api/controllers/userController";
// import InfoIcon from "@mui/icons-material/Info";
import { FieldHeading, FieldValue } from "../userProfileDetail";
export const UserProfile = ({ tableView, setTableView, index, admin }) => {
  // context
  const scrollerAll = useRef(null);
  const scrollerDemo = useRef(null);
  const scrollerStandard = useRef(null);
  const [ancher, setAncher] = useState(null);
  const navigate = useNavigate();
  const {
    isOpenRegisterEmployeeDialog,
    setGlobalLoader,
    setIsOpenRegisterEmployeeDialog,
    isOpenEditEmployeeDialog,
    setIsOpenEditEmployeeDialog,
    isOpenDeleteEmployeeDialog,
    setIsOpenDeleteEmployeeDialog,
    isOpenUploadEmployeeDialog,
    employeesList,
    setEmployeesList,
    registerDetails,
    setRegisterDetails,
    setLicenceBatchList,
    filteredList,
    setFilteredList,
    header,
    licenceBatchList,
    setAuditList,
    profileDetails,
  } = useContext(ApplicationContext);
  // const scrollerAll = useRef(null);
  // const scrollerDemo = useRef(null);
  // const scrollerStandard = useRef(null);
  const [inviteLoader, setInviteLoader] = useState(false);
  let totalLicence =
    header === "Trial"
      ? licenceBatchList[0]?.totalLicenses
      : licenceBatchList
          ?.slice(1)
          ?.map((data) => data?.totalLicenses)
          ?.reduce((a, b) => a + b, 0) ?? 0;

  let allocatedLicence =
    header === "Trial"
      ? licenceBatchList[0]?.allocatedLicenses
      : licenceBatchList
          ?.slice(1)
          ?.map((data) => data?.allocatedLicenses)
          ?.reduce((a, b) => a + b, 0) ?? 0;

  let unallocatedLicence =
    header === "Trial"
      ? licenceBatchList[0]?.totalLicenses -
        licenceBatchList[0]?.allocatedLicenses
      : licenceBatchList
          ?.slice(1)
          ?.map((data) => data?.totalLicenses)
          ?.reduce((a, b) => a + b, 0) -
          licenceBatchList
            ?.slice(1)
            ?.map((data) => data?.allocatedLicenses)
            ?.reduce((a, b) => a + b, 0) ?? 0;

  let totalCombo =
    licenceBatchList
      ?.map((data) => data?.totalLicenses)
      ?.reduce((a, b) => a + b, 0) ?? 0;

  let totalDemoLicence = licenceBatchList[0]?.totalLicenses;

  let totalStandardLicence =
    licenceBatchList
      ?.slice(1)
      ?.map((data) => data?.totalLicenses)
      ?.reduce((a, b) => a + b, 0) ?? 0;
  const location = useLocation();
  const profileQuery = useMediaQuery("(max-width:1214px)");

  const fetchDataArrayLength = 4;
  const checkboxOption = {
    delete: "delete",
    allocate: "allocate",
    unallocate: "unallocate",
  };

  const [tabs] = useState(0);
  const [openRevokeConfirm, setOpenRevokeConfirm] = useState(false);
  const [uploadLength, setUploadLength] = useState(0);
  const [openUploadConfirm, setOpenUploadConfirm] = useState(false);
  const [touchUpload, setTouchUpload] = useState(false);
  const [csvFile, setCsvFile] = useState({});
  const [scrollerTrigger, setScrollerTrigger] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(false);
  // const [filteredList, setFilteredList] = useState([]);
  // const [ setCheckboxAnchorEl] = useState(null);
  const [currentCheckBoxOption, setCurrentCheckBoxOption] = useState(
    checkboxOption.allocate
  );

  const [rowSelecter, setRowSelector] = useState([]);
  const [rowSelecterDeallocated, setRowSelectorDeallocated] = useState([]);
  const [revokedEmployeesData] = useState([]);
  const [loaderState, setLoaderState] = useState(false);
  // const [ setApiLoader] = useState(false);
  // const [ setDragHighlight] = useState(false);
  const [setReloadEmployees] = useState(false);

  const [newEditRowIndex, setNewEditRowIndex] = useState(null);
  const [onBoardSnack, setOnBoardSnack] = useState(false);
  const [error, setError] = useState("");
  const [searchedEmpQuery, setSearchedEmpQuery] = useState("");
  const [currentRowIndex, setCurrentRowIndex] = useState(null);
  const [isShowMoreIndex, setIsShowMoreIndex] = useState(null);

  const [filterType] = useState({
    designation: "epDesignation",
    licenceStatus: "licenseStatus",
  });

  const [filterDetail] = useState({
    type: "",
    value: "",
  });

  // const [ setFilterDesignationAnchorEl] =
  //   React.useState(null);
  // const [ setFilterLicenceStatusAnchorEl] =
  //   React.useState(null);

  console.log(location, "current location");

  // const onDrop = async (e) => {
  //   setApiLoader(true);
  //   console.log(e.dataTransfer.files[0]);
  //   e.preventDefault();
  //   if (e.dataTransfer.files[0].type === "text/csv") {
  //     // setCsvFile(e.dataTransfer.files[0]);
  //     await uploadDoc(e.dataTransfer.files[0]);
  //   } else {
  //     setApiLoader(false);
  //     setDragHighlight(false);
  //     setError("only CSV files are allowed to upload");
  //     setOnBoardSnack(true);
  //   }
  // };
  let demoLicenceCount =
    licenceBatchList[0]?.totalLicenses - licenceBatchList[0]?.allocatedLicenses;
  let standardLicenceCount =
    licenceBatchList
      ?.slice(1)
      ?.map((data) => data?.totalLicenses)
      ?.reduce((a, b) => a + b, 0) -
    licenceBatchList
      ?.slice(1)
      ?.map((data) => data?.allocatedLicenses)
      ?.reduce((a, b) => a + b, 0);

  const onFileSelect = async (e) => {
    console.log("file select");
    e.preventDefault();
    setCsvFile(e.target.files[0]);
    // setApiLoader(true);
    // let boolean = false
    let dd = Papa.parse(e.target.files[0], {
      header: true,
      skipEmptyLines: true,
      complete: function (results) {
        setUploadLength(results?.data?.length);
        console.log(results?.data?.length > standardLicenceCount, "checkcond");
        if (
          header === "Trial"
            ? results?.data?.length > demoLicenceCount
            : results?.data?.length > standardLicenceCount
        ) {
          console.log("yesOpenUpload");
          setOpenUploadConfirm(true);
        } else {
          console.log("yesDirectUpload");
          // setTouchUpload(true);
          setOpenUploadConfirm(true);
          // setTouchUpload(true);

          // console.log(boolean,'checkBoolean')
          // boolean = true
        }
        console.log(results.data, "checkdd");
      },
    });
    console.log(dd, "checkBoolean");

    console.log(e.target.files[0], "checkTarget");

    e.target.value = "";
  };

  console.log(csvFile, "check");

  const uploadDoc = async (file) => {
    console.log(csvFile, "yesfileupload");
    // setGlobalLoader(true);
    setOpenUploadConfirm(false);
    setUploadProgress(true);
    try {
      // setApiLoader(true);
      let response = await uploadCVS(
        {
          file: csvFile,
        },
        header
      );
      // setApiLoader(false);

      console.log(response, "responseLogin");
      if (response.status === HttpStatusCode.Ok) {
        // setCsvFile({});
        // setGlobalLoader(false);

        // setApiLoader(false);

        // setDragHighlight(false);
        setError(
          response?.data?.employees?.length === 0
            ? "Some employees already exist"
            : response.data.message
        );
        setOnBoardSnack(true);
        let reloadBatch = await getLicencBatch();
        let reloadEmployee = await getUploadCVS();
        let reloadAudit = await getAudit();

        setAuditList(reloadAudit.data?.auditLogs);
        setEmployeesList(reloadEmployee.data);
        setLicenceBatchList(reloadBatch.data);
        // document.getElementById("inputClick")?.value = "";
        // document.getElementById("inputClick").reset();

        setFilteredList([...filteredList, ...response.data.employees]);
        setTouchUpload(false);
        setUploadProgress(false);

        // setReloadEmployees(true);
        // setTimeout(() => {
        //   setReloadEmployees(false);
        // }, 400);
      }
      if (response.status === HttpStatusCode.BadRequest) {
        setGlobalLoader(false);
        setTouchUpload(false);
        setOpenUploadConfirm(false);
        setUploadProgress(false);

        setError(response.data.message);
        setOnBoardSnack(true);
      }
      if (response.status === HttpStatusCode.InternalServerError) {
        setGlobalLoader(false);
        setTouchUpload(false);
        setOpenUploadConfirm(false);
        setUploadProgress(false);

        // setApiLoader(false);
        // setDragHighlight(false);
        setError(response.data.message);
        setOnBoardSnack(true);
        setUploadProgress(false);
      }
      if (response.status === HttpStatusCode.BadGateway) {
        setGlobalLoader(false);
        setTouchUpload(false);
        setOpenUploadConfirm(false);
        setUploadProgress(false);

        // setApiLoader(false);
        // setDragHighlight(false);
        setError(response.data.message);
        setOnBoardSnack(true);
        setUploadProgress(false);
      }

      if (response.status === HttpStatusCode.Forbidden) {
        setGlobalLoader(false);

        // setApiLoader(false);
        // setDragHighlight(false);
        setError(response.data.message);
        setTouchUpload(false);
        setOpenUploadConfirm(false);

        setOnBoardSnack(true);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (touchUpload) {
      uploadDoc();
    }
    // eslint-disable-line react-hooks/exhaustive-deps
  }, [touchUpload, csvFile]); // eslint-disable-line react-hooks/exhaustive-deps

  console.log(
    document.getElementById("file")?.value,
    "value",
    document.getElementById("file")?.file,
    "file"
  );

  // function handleAddRow() {
  //   setIsOpenRegisterEmployeeDialog(true);

  //   // let tempData = [...employeesList];

  //   // let lastTempData = tempData[tempData?.length - 1]

  //   // if (!lastTempData?.epId?.length) {
  //   //   lastTempData.epId = "EMPTY"
  //   // }
  //   // if (!lastTempData?.epName?.length) {
  //   //   lastTempData.epName = "EMPTY"
  //   // }
  //   // if (!lastTempData?.epEmail?.length) {
  //   //   lastTempData.epEmail = "EMPTY"
  //   // }
  //   // if (!lastTempData?.epDesignation?.length) {
  //   //   lastTempData.epDesignation = "EMPTY"
  //   // }

  //   // tempData[tempData?.length - 1] = lastTempData

  //   // console.log(tempData);

  //   // setCurrentRowIndex(employeesList.length);
  //   // setNewEditRowIndex(employeesList.length);

  //   // employeesList.push({
  //   //   epId: "",
  //   //   epName: "",
  //   //   epEmail: "",
  //   //   epDesignation: "",
  //   //   licenseStatus: 'unallocated'
  //   // });
  //   // setEmployeesList([...employeesList]);

  //   // setRegisterDetails({
  //   //   epId: null,
  //   //   epName: null,
  //   //   epEmail: null,
  //   //   epDesignation: null,
  //   // });
  //   // let p = { empid: "", emName: "", epDesig: "", epEmail: "" };

  //   // console.log(employeesList.length, "length")
  // }

  // function handleAllocateMultipleEmployee() {
  //   let array = [...rowSelecter];
  // }

  // function handleDeallocateMultipleEmployee() {
  //   let array = [...rowSelecter];
  // }

  console.log(filterDetail, "filterdetail");

  // const handleClickFilterDesignation = (event, value) => {
  //   // setFilterDetail({ ...filterDetail, type: value })
  //   setFilterDesignationAnchorEl(event.currentTarget);
  // };
  // const handleCloseFilterDesignation = () => {
  //   setFilterDesignationAnchorEl(null);
  // };

  // const handleClickFilterLicenceStatus = (event, value) => {
  //   // setFilterDetail({ ...filterDetail, type: value })
  //   setFilterLicenceStatusAnchorEl(event.currentTarget);
  // };
  // const handleCloseFilterLicenceStatus = () => {
  //   setFilterLicenceStatusAnchorEl(null);
  // };

  // const handleClickCheckBoxOptions = (event) => {
  //   setCheckboxAnchorEl(event.currentTarget);
  // };
  // const handleCloseCheckBoxOptions = () => {
  //   setCheckboxAnchorEl(null);
  // };

  const handleRevokeEmployee = async (currentData) => {
    console.log("pressed");
    setOpenRevokeConfirm(false);
    setGlobalLoader(true);
    let ids = rowSelecter.map((data, i) => data._id);
    console.log(ids.slice(0, 500), "idd");
    try {
      setLoaderState(true);
      let response = await revokeMultipleUser({
        employeeIds:
          rowSelecter.length !== 0 ? ids.slice(0, 500) : [registerDetails._id],
      });

      setGlobalLoader(false);
      console.log(response, "response revoke");
      if (response.status === HttpStatusCode.Ok) {
        setError(response.data.message);
        setOnBoardSnack(true);

        setLoaderState(true);

        let reload = await getUploadCVS();
        setEmployeesList(reload.data);
        setFilteredList([
          ...reload.data.filter(
            (id) =>
              id.licenseType === (header === "Trial" ? "Trial" : "Standard")
          ),
        ]);
        setRowSelector([]);
        // setFilteredList(filteredList.filter((filterid)=>));
        // setEmployeesList(tempArray);

        let reloadDashboard = await getLicencBatch();
        setLicenceBatchList(reloadDashboard.data);
        setCurrentRowIndex(null);
        let reloadAudit = await getAudit();
        console.log(reloadAudit, "getAudit");

        setAuditList(reloadAudit.data?.auditLogs);

        // setReloadEmployees(true);
        // setTimeout(() => {
        //   setReloadEmployees(false);
        // }, 400);
      }
      if (response.status === HttpStatusCode.BadRequest) {
        setLoaderState(true);

        setError(response.data.message);
        setOnBoardSnack(true);
      }
      if (response.status === HttpStatusCode.InternalServerError) {
        setError(response.data.message);
        setLoaderState(true);

        setOnBoardSnack(true);
      }

      if (response.status === HttpStatusCode.Forbidden) {
        setLoaderState(true);

        setError(response.data.message);
        setOnBoardSnack(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleUnRevokeEmployee = async (currentData) => {
    try {
      setLoaderState(true);
      let response = await unRevokeMultipleUser({
        employeeIds: [currentData._id],
      });

      setLoaderState(false);
      console.log(response, "response revoke");
      if (response.status === HttpStatusCode.Ok) {
        setError(response.data.message);
        setOnBoardSnack(true);

        let tempArray = [...filteredList];

        let foundIndex = filteredList.findIndex(
          (x) => x._id === currentData?._id
        );
        tempArray[foundIndex].downloadedApplication = true;
        // let responseReload = await getUploadCVS();
        // console.log(response, "getEmployees");
        //   setEmployeesList(responseReload.data);
        // setFilteredList(response.data);

        setFilteredList(tempArray);
        let reloadDashboard = await getLicencBatch();
        setLicenceBatchList(reloadDashboard.data);

        // setReloadEmployees(true);
        // setTimeout(() => {
        //   setReloadEmployees(false);
        // }, 400);
      }
      if (response.status === HttpStatusCode.BadRequest) {
        setError(response.data.message);
        setOnBoardSnack(true);
      }
      if (response.status === HttpStatusCode.InternalServerError) {
        setError(response.data.message);
        setOnBoardSnack(true);
      }

      if (response.status === HttpStatusCode.Forbidden) {
        setError(response.data.message);
        setOnBoardSnack(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const handleRevokeMultipleEmployee = async () => {
  //   console.log("revoke");

  //   try {
  //     let idArray = [];

  //     rowSelecter.map((item, index) => {
  //       idArray.push(item._id);
  //     });

  //     console.log(idArray, "idArray");

  //     setLoaderState(true);
  //     let response = await revokeMultipleUser({
  //       employeeIds: idArray,
  //     });

  //     setLoaderState(false);
  //     console.log(response, "response revoke");
  //     if (response.status === HttpStatusCode.Ok) {
  //       setError(response.data.message);
  //       setOnBoardSnack(true);

  //       // let tempArray = [...filteredList]

  //       // let foundIndex = filteredList.findIndex(x => x._id === currentData?._id);
  //       // tempArray[foundIndex] = response.data.updatedEmployee;

  //       // setFilteredList(tempArray);

  //       let tempArray = [...filteredList];

  //       idArray.map((id, index) => {
  //         let foundIndex = filteredList.findIndex((x) => x._id === id);
  //         tempArray[foundIndex].downloadedApplication = false;
  //       });

  //       setFilteredList(tempArray);

  //       setRowSelector([]);
  //       let reloadDashboard = await getLicencBatch();
  //       setLicenceBatchList(reloadDashboard.data);

  //       // setReloadEmployees(true);
  //       // setTimeout(() => {
  //       //   setReloadEmployees(false);
  //       // }, 400);
  //     }
  //     if (response.status === HttpStatusCode.BadRequest) {
  //       setError(response.data.message);
  //       setOnBoardSnack(true);
  //     }
  //     if (response.status === HttpStatusCode.InternalServerError) {
  //       setError(response.data.message);
  //       setOnBoardSnack(true);
  //     }

  //     if (response.status === HttpStatusCode.Forbidden) {
  //       setError(response.data.message);
  //       setOnBoardSnack(true);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const handleUnRevokeMultipleEmployee = async () => {
  //   console.log("unrevoke");

  //   let idArray = [];

  //   rowSelecter.map((item, index) => {
  //     idArray.push(item._id);
  //   });

  //   console.log(idArray, "unrevoke array");

  //   try {
  //     setLoaderState(true);
  //     let response = await unRevokeMultipleUser({
  //       employeeIds: idArray,
  //     });

  //     setLoaderState(false);
  //     console.log(response, "response revoke");
  //     if (response.status === HttpStatusCode.Ok) {
  //       setError(response.data.message);
  //       setOnBoardSnack(true);

  //       let tempArray = [...filteredList];

  //       idArray.map((id, index) => {
  //         let foundIndex = filteredList.findIndex((x) => x._id === id);
  //         tempArray[foundIndex].downloadedApplication = true;
  //       });
  //       // let foundIndex = filteredList.findIndex(x => x._id === currentData?._id);
  //       // tempArray[foundIndex] = response.data.updatedEmployee;

  //       setFilteredList(tempArray);
  //       setRowSelector([]);

  //       let reloadDashboard = await getLicencBatch();
  //       setLicenceBatchList(reloadDashboard.data);

  //       // setReloadEmployees(true);
  //       // setTimeout(() => {
  //       //   setReloadEmployees(false);
  //       // }, 400);
  //     }
  //     if (response.status === HttpStatusCode.BadRequest) {
  //       setError(response.data.message);
  //       setOnBoardSnack(true);
  //     }
  //     if (response.status === HttpStatusCode.InternalServerError) {
  //       setError(response.data.message);
  //       setOnBoardSnack(true);
  //     }

  //     if (response.status === HttpStatusCode.Forbidden) {
  //       setError(response.data.message);
  //       setOnBoardSnack(true);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // useEffect(() => {
  //   //setGlobalLoader(true);
  //   const getEmployees = async () => {
  //     try {
  //       let response = await getUploadCVS();
  //       console.log(response, "getEmployees");
  //       if (response.status === HttpStatusCode.Ok) {
  //         setTimeout(() => {
  //           setGlobalLoader(false);
  //         }, 2000);
  //         setEmployeesList(response.data);
  //         setFilteredList(response.data);
  //       }
  //       if (response.status === HttpStatusCode.Unauthorized) {
  //         navigate("/signin");
  //       }

  //       // setEmployeesData(response.data);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };

  //   getEmployees();
  // }, [reloadEmployees]);

  useEffect(() => {
    // setFilteredList([...employeesList]);
  }, [employeesList]);

  useEffect(() => {
    setRowSelector([]);
  }, [currentCheckBoxOption, filterDetail.value]);

  useEffect(() => {
    if (filterDetail.value) {
      if (filterDetail.type === filterType.designation) {
        setFilteredList(
          employeesList.filter(
            (data, i) =>
              data.designation === filterDetail.value &&
              (header === "Trial"
                ? data.licenseType === "Trial"
                : header === "Standard"
                ? data.licenseType === "Standard"
                : header === "Employees"
                ? data.licenseType
                : "")
          )
        );
      }
      if (filterDetail.type === filterType.licenceStatus) {
        setFilteredList(
          employeesList.filter(
            (data, i) =>
              data.downloadedApplication ===
                (filterDetail.value === "active") &&
              (header === "Standard"
                ? data.licenseType === "Standard"
                : header === "Employees"
                ? data.licenseType
                : "")
          )
        );
      }

      // console.log(list, "list");
      // setFilteredList(list);
      // handleCloseFilterDesignation();
      // handleCloseFilterLicenceStatus();
    } else {
      setFilteredList(
        employeesList.filter((data, i) =>
          header === "Employees"
            ? data.licenseType
            : data.licenseType === (header === "Trial" ? "Trial" : "Standard")
        )
      );
    }

    // console.log(tempArray, "tempArray");
  }, [filterDetail.value]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // setRowSelector([...employeesList?.filter((item) => item.licenseStatus === "allocated")]);
    // setRowSelectorDeallocated([...employeesList?.filter((item) => item.licenseStatus === "unallocated")]);
  }, [employeesList]);

  let uniqueDesignation = [
    ...new Set(employeesList?.map((item) => item.epDesignation)),
  ];
  console.log(uniqueDesignation, "uniquedesignation");

  console.log(rowSelecter, "rowselector");
  // filteredList[2].downloadedApplication = false
  // console.log(rowSelecterDeallocated, "rowselectordeallocated");

  // console.log(employeesList, "row");
  // console.log(employeesList, rowSelecter, "detailss");

  // const uniqueStatus = [];
  // for (const item of employeesList) {
  //   const status = item.downloadedApplication;
  //   if (uniqueStatus.indexOf(status) === -1) {
  //     uniqueStatus.push(status);
  //   }
  // }
  // console.log(uniqueStatus, "uniqueStatus")
  // let uniqueStatus2 = [...new Set(employeesList.map((item) => (item.downloadedApplication).toString()))];
  // console.log(uniqueStatus2, "uniquesStatus")

  console.log(filteredList, "filterd");

  const handleBack = async () => {
    // setFilteredList([...employeesList])
    setTableView(0);
    try {
      let response = await getUploadCVS();

      console.log(response, "getEmployees");
      if (response.status === HttpStatusCode.Ok) {
        setEmployeesList(response.data);
        // setFilteredList(response.data);
      }
      if (response.status === HttpStatusCode.Unauthorized) {
        navigate("/signin");
      }

      // setEmployeesData(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (header === "Trial") {
      setFilteredList(
        employeesList.filter((data) => data.licenseType === "Trial")
      );
    }
    if (header === "Standard") {
      setFilteredList(
        employeesList.filter((data) => data.licenseType === "Standard")
      );
    }

    if (header === "Employees") {
      setFilteredList(employeesList.filter((data) => data));
    }
  }, [header]); // eslint-disable-line react-hooks/exhaustive-deps
  console.log(filteredList, "afterfilterOnboards");

  useEffect(() => {
    console.log("Scrolleron");
    if (scrollerTrigger) {
      console.log("ScrolleronInside");

      scrollerAll?.current?.scrollIntoView({
        index: filteredList.length - 1,
        behavior: "smooth",
      });
      setTimeout(() => {
        setScrollerTrigger(false);
      }, 4000);
    }
  }, [scrollerTrigger, filteredList]); // eslint-disable-line react-hooks/exhaustive-deps

  let result = filteredList?.filter(
    (empData, index) =>
      empData.employeeId
        ?.toLowerCase()
        .includes(searchedEmpQuery?.toLowerCase()) ||
      empData.name?.toLowerCase().includes(searchedEmpQuery?.toLowerCase()) ||
      empData.email?.toLowerCase().includes(searchedEmpQuery?.toLowerCase()) ||
      empData.designation
        ?.toLowerCase()
        .includes(searchedEmpQuery?.toLowerCase()) ||
      empData.licenseType
        ?.toLowerCase()
        .includes(searchedEmpQuery?.toLowerCase()) ||
      empData?.downloadedApplication ===
        (searchedEmpQuery?.toLowerCase() === "active"
          ? true
          : searchedEmpQuery?.toLowerCase() === "inactive"
          ? false
          : "")
  );

  const handleInvite = async (details) => {
    setInviteLoader(true);
    try {
      let response = await inviteEmployee({
        email: details.email,
        employeeName: details.name,
        organizationName: profileDetails.companyName,
      });
      if (response.status === HttpStatusCode.Ok) {
        setInviteLoader(false);

        setError(response.data.message);
        setOnBoardSnack(true);
      }
      if (response.status === HttpStatusCode.BadRequest) {
        setInviteLoader(false);

        setError(response.data.message);
        setOnBoardSnack(true);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        // border={"1px solid rgb(229, 234, 242)"}
        width="100%"
        // paddingTop="24px"
        flexDirection={profileQuery ? "column" : "row"}
        // height="2950px"
        gap="24px"
      >
        {tabs === 0 ? (
          <>
            {/* registered count and address */}

            {/* table maincontainer */}
            <Box
              display="flex"
              flexDirection="column"
              width={"100%"}
              // minHeight="592px"
              backgroundColor={theme.col_4}
              // borderRadius="8px"
              border={"1px solid rgb(229, 234, 242)"}
            >
              {/* table header */}
              <Box
                display="flex"
                // alignItems="center"
                flexDirection="column"
                width={"100%"}
                // gap="21px"
                // border="2px solid blue"
              >
                <Box
                  display="flex"
                  alignItems="center"
                  px={2}
                  py={2}
                  width={"auto"}
                  // height="90px"
                  // justifyContent="flex-end"
                  gap={2}
                  // border="2px solid blue"
                  // gap="21px"
                >
                  {console.log(searchedEmpQuery, "searchedempquery")}

                  {/* search container */}
                  <Box display="flex" alignItems="center" flex={1}>
                    {tableView ? (
                      <Box py={1}>
                        <IconButton onClick={handleBack}>
                          <IconBack />
                        </IconButton>
                      </Box>
                    ) : (
                      <></>
                    )}
                    <TextFieldMA
                      id="emp"
                      type="search"
                      defaultValue={searchedEmpQuery}
                      // disabled
                      onChange={(e) => setSearchedEmpQuery(e.target.value)}
                      size="small"
                      fullWidth
                      placeholder="Search Employee"
                      InputProps={{
                        style: {
                          border: "none",
                        },
                        startAdornment: (
                          <InputAdornment>
                            <IconButton size="small">
                              <Search />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        background: grey[100],
                        borderRadius: "32px",
                        "& fieldset": { border: "none" },
                        "&.MuiInputBase-formControl": {
                          border: "none",
                          outline: "none",
                        },
                      }}
                    />
                  </Box>

                  {/* <TooltipMA title="Download Template" arrow>
                  <IconButtonMA
                    size="small"
                    onClick={() => {
                      // setIsOpenUploadEmployeeDialog(true)
                    }}
                  >
                    <Download />
                  </IconButtonMA>
                </TooltipMA>

                <TooltipMA title="Upload Employees" arrow>
                  <IconButtonMA
                    size="small"
                    onClick={() =>
                      document.getElementById("inputClick").click()
                    }
                  >
                    <Upload />

                    <VisuallyHiddenInput
                      onChange={onFileSelect}
                      id="inputClick"
                      type="file"
                      accept=".csv"
                    />
                  </IconButtonMA>
                </TooltipMA>

                <TooltipMA title="Register Employee" arrow>
                  <IconButtonMA
                    size="small"
                    onClick={() => {
                      handleAddRow();
                    }}
                  >
                    <Add />
                  </IconButtonMA>
                </TooltipMA> */}
                </Box>

                {/* sub header */}
                <Box
                  width="auto"
                  display="flex"
                  alignItems="center"
                  px={2.2}
                  py={2}
                  pt={0}
                  gap={2}
                  overflow="auto"
                >
                  {/* <Button
                  id="demo-customized-button"
                  aria-controls={
                    checkboxAnchorEl ? "demo-customized-menu" : undefined
                  }
                  aria-haspopup="true"
                  aria-expanded={checkboxAnchorEl ? "true" : undefined}
                  variant="contained"
                  disableElevation
                  onClick={handleClickCheckBoxOptions}
                  endIcon={<KeyboardArrowDown />}
                  // sx={{ borderRadius: "28px", background: theme.col_2_alpha, color: theme.col_2, "&:hover": { background: theme.col_2_alpha, } }}
                  sx={{
                    borderRadius: "28px",
                    background:
                      currentCheckBoxOption === checkboxOption.delete
                        ? theme.statusDanger
                        : currentCheckBoxOption === checkboxOption.allocate
                        ? theme.statusSuccess
                        : currentCheckBoxOption === checkboxOption.unallocate
                        ? theme.statusWarning
                        : theme.statusWarningAlpha,
                    color: theme.col_4,
                    "&:hover": {
                      background:
                        currentCheckBoxOption === checkboxOption.delete
                          ? theme.statusDanger
                          : currentCheckBoxOption === checkboxOption.allocate
                          ? theme.statusSuccess
                          : currentCheckBoxOption === checkboxOption.unallocate
                          ? theme.statusWarning
                          : theme.statusWarningAlpha,
                    },
                  }}
                >
                  {currentCheckBoxOption}
                </Button> */}

                  {/* <Menu
                  id="demo-customized-menu"
                  MenuListProps={{
                    "aria-labelledby": "demo-customized-button",
                  }}
                  anchorEl={checkboxAnchorEl}
                  open={Boolean(checkboxAnchorEl)}
                  onClose={handleCloseCheckBoxOptions}
                >
                
                  <MenuItem
                    onClick={() => {
                      handleCloseCheckBoxOptions();
                      setCurrentCheckBoxOption(checkboxOption.allocate);
                    }}
                    disableRipple
                  >
                    Allocate Licence
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleCloseCheckBoxOptions();
                      setCurrentCheckBoxOption(checkboxOption.unallocate);
                    }}
                    disableRipple
                  >
                    Unallocate Licence
                  </MenuItem>
                </Menu> */}

                  {/* {currentCheckBoxOption === checkboxOption.allocate && (
                  <TooltipMA title="Allocate Employee">
                    <IconButtonMA
                      disabled={rowSelecter.length <= 0}
                      size="small"
                      onClick={() => handleUnRevokeMultipleEmployee()}
                      sx={{
                        background: `${theme.statusSuccess} !important`,
                        color: `${theme.col_4} !important`,
                        "&:disabled": {
                          background: `${theme.statusDisabledAlpha} !important`,
                          color: `${theme.statusDisabled} !important`,
                        },
                      }}
                    >
                      <PersonAddAltIcon />
                    </IconButtonMA>
                  </TooltipMA>
                )} */}

                  {/* {currentCheckBoxOption === checkboxOption.unallocate && (
                  <TooltipMA title="Deallocate Employee">
                    <IconButtonMA
                      disabled={rowSelecter.length <= 0}
                      size="small"
                      onClick={() => handleRevokeMultipleEmployee()}
                      sx={{
                        background: `${theme.statusWarning} !important`,
                        color: `${theme.col_4} !important`,
                        "&:disabled": {
                          background: `${theme.statusDisabledAlpha} !important`,
                          color: `${theme.statusDisabled} !important`,
                        },
                      }}
                    >
                      <PersonOffIcon />
                    </IconButtonMA>
                  </TooltipMA>
                )} */}

                  {header === "Employees" ? (
                    <>
                      <Box
                        display="flex"
                        // flexDirection="column"
                        gap="10px"
                        height="100%"
                        width="100%"
                        overflow="auto"
                        sx={{
                          minWidth: "fit-content",
                          maxWidth: "fit-content",
                        }}
                      >
                        <Typography
                          color={theme.col_6}
                          fontWeight="bold"
                          // display="flex"
                          gap="4px"
                          whiteSpace="nowrap"
                        >
                          Total Licence{" "}
                          <Typography color={theme.col_6}>
                            {totalCombo}
                          </Typography>
                        </Typography>
                        <Typography
                          color={theme.col_6}
                          fontWeight="bold"
                          // display="flex"
                          gap="4px"
                          whiteSpace="nowrap"
                        >
                          Trial Licence{" "}
                          <Typography color={theme.col_6}>
                            {totalDemoLicence}
                          </Typography>
                        </Typography>
                        <Typography
                          color={theme.col_6}
                          fontWeight="bold"
                          // display="flex"
                          gap="4px"
                          whiteSpace="nowrap"
                        >
                          Standard Licence{" "}
                          <Typography color={theme.col_6}>
                            {totalStandardLicence}
                          </Typography>
                        </Typography>
                      </Box>
                    </>
                  ) : (
                    <Box
                      display="flex"
                      // flexDirection="column"
                      gap="10px"
                      height="100%"
                      width="100%"
                      overflow="auto"
                      sx={{
                        minWidth: "fit-content",
                        maxWidth: "fit-content",
                      }}
                    >
                      <Typography
                        // onClick={() =>
                        //   //  setTimeout(() => {
                        //   //   let height = document.getElementById("scroller").scrollHeight
                        //   //   let ele = document.getElementById("scroller").scrollBy({top:height,behavior:'smooth'})
                        //   //  }, 1000)
                        //   scrollerAll.current?.scrollIntoView({
                        //     index: filteredList.length,
                        //     align: "end",
                        //     behavior: "smooth",
                        //   })
                        // }
                        color={theme.col_6}
                        fontWeight="bold"
                        // display="flex"
                        gap="4px"
                        whiteSpace="nowrap"
                      >
                        Total{" "}
                        <Typography color={theme.col_6}>
                          {totalLicence}
                        </Typography>
                      </Typography>
                      <Typography
                        color={theme.col_6}
                        fontWeight="bold"
                        // display="flex"
                        gap="4px"
                        whiteSpace="nowrap"
                      >
                        Allocated{" "}
                        <Typography color={theme.col_6}>
                          {allocatedLicence}
                        </Typography>
                      </Typography>
                      <Typography
                        color={theme.col_6}
                        fontWeight="bold"
                        // display="flex"
                        gap="4px"
                        whiteSpace="nowrap"
                      >
                        Unallocated{" "}
                        <Typography color={theme.col_6}>
                          {unallocatedLicence}
                        </Typography>
                      </Typography>
                      {rowSelecter.length !== 0 ? (
                        <Typography
                          color={theme.col_6}
                          fontWeight="bold"
                          // display="flex"
                          gap="4px"
                          whiteSpace="nowrap"
                        >
                          Selection{" "}
                          <Typography color={theme.col_6}>
                            {`${rowSelecter.length} / ${filteredList.length}`}
                          </Typography>
                        </Typography>
                      ) : (
                        <></>
                      )}
                    </Box>
                  )}

                  {/* {currentCheckBoxOption === checkboxOption.delete && <TooltipMA title="Delete Employee">
                  <IconButtonMA disabled={rowSelecter.length <= 0} size="small" sx={{
                    background: `${theme.statusDanger} !important`, color: `${theme.col_4} !important`,
                    "&:disabled": { background: `${theme.statusDisabledAlpha} !important`, color: `${theme.statusDisabled} !important`, }
                  }}>
                    <Delete />
                  </IconButtonMA>
                </TooltipMA>} */}

                  {/* <Box
                    display="flex"
                    // flex={1}
                    alignItems="center"
                    justifyContent="flex-end"
                    gap={2}
                    px={4}
                  >
                    <ButtonMA
                      id="demo-customized-button"
                      aria-controls={
                        Boolean(filterDesignationAnchorEl)
                          ? "demo-customized-menu"
                          : undefined
                      }
                      aria-haspopup="true"
                      aria-expanded={
                        Boolean(filterDesignationAnchorEl) ? "true" : undefined
                      }
                      variant="text"
                      disableElevation
                      disabled={
                        [
                          ...new Set(
                            employeesList?.map((item) => item.designation)
                          ),
                        ].length === 0
                      }
                      size="small"
                      onClick={(e) =>
                        handleClickFilterDesignation(e, filterType.designation)
                      }
                      endIcon={<KeyboardArrowDown />}

                      sx={{
                        background:
                          filterDetail.type === filterType.designation
                            ? `${theme.col_2_alpha} !important`
                            : `none !important`,
                        color: `${theme.col_11} !important`,
                        "&:hover": {
                          background: `${theme.col_2_alpha} !important`,
                        },
                      }}
                    >
                      Employee Designation
                    </ButtonMA>

                    <ButtonMA
                      id="demo-customized-button"
                      aria-controls={
                        Boolean(filterLicenceStatusAnchorEl)
                          ? "demo-customized-menu"
                          : undefined
                      }
                      aria-haspopup="true"
                      aria-expanded={
                        Boolean(filterLicenceStatusAnchorEl)
                          ? "true"
                          : undefined
                      }
                      variant="text"
                      disableElevation
                      size="small"
                      onClick={(e) =>
                        handleClickFilterLicenceStatus(
                          e,
                          filterType.licenceStatus
                        )
                      }
                      endIcon={<KeyboardArrowDown />}
                      sx={{
                        background:
                          filterDetail.type === filterType.licenceStatus
                            ? `${theme.col_2_alpha} !important`
                            : `none !important`,
                        color: `${theme.col_11} !important`,
                        "&:hover": {
                          background: `${theme.col_2_alpha} !important`,
                        },
                      }}
                    >
                      Licence Status
                    </ButtonMA>

                    <IconButtonMA
                      size="small"
                      onClick={() => setFilterDetail({ type: "", value: "" })}
                      sx={{
                        visibility:
                          filterDetail.value || filterDetail.type
                            ? "visible"
                            : "hidden",
                      }}
                    >
                      <Close />
                    </IconButtonMA>

                    <Menu
                      id="demo-customized-menu"
                      MenuListProps={{
                        "aria-labelledby": "demo-customized-button",
                      }}
                      anchorEl={filterDesignationAnchorEl}
                      open={Boolean(filterDesignationAnchorEl)}
                      onClose={handleCloseFilterDesignation}
                    >
                      {[
                        ...new Set(
                          employeesList
                            .filter((data) =>
                              header === "Employees"
                                ? data.licenseType
                                : data.licenseType ===
                                  (header === "Trial" ? "demo" : "Standard")
                            )
                            ?.map((item) => item.designation)
                        ),
                      ].map((it, index) => {
                        return (
                          <MenuItem
                            onClick={() =>
                              setFilterDetail({
                                type: filterType.designation,
                                value: it,
                              })
                            }
                            disableRipple
                          >
                            {it}
                          </MenuItem>
                        );
                      })}
                    </Menu>

                    <Menu
                      id="demo-customized-menu"
                      MenuListProps={{
                        "aria-labelledby": "demo-customized-button",
                      }}
                      anchorEl={filterLicenceStatusAnchorEl}
                      open={Boolean(filterLicenceStatusAnchorEl)}
                      onClose={handleCloseFilterLicenceStatus}
                    >
                  

                      <MenuItem
                        onClick={() =>
                          setFilterDetail({
                            type: filterType.licenceStatus,
                            value: "active",
                          })
                        }
                        disableRipple
                      >
                        Active
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          console.log("enteredddd");
                          setFilterDetail({
                            type: filterType.licenceStatus,
                            value: "expired",
                          });
                        }}
                        disableRipple
                      >
                        Expired
                      </MenuItem>
                    </Menu>
                  </Box> */}
                  {header === "Employees" || admin ? (
                    <></>
                  ) : (
                    <Box
                      flex="1"
                      display="flex"
                      gap="12px"
                      justifyContent="flex-end"
                      alignItems="center"
                    >
                      <ButtonCustom
                        onClick={() =>
                          window.open(
                            "https://mindamigo.com/wp-content/uploads/2024/01/Mindamigo-bulk-update.csv",
                            "_self"
                          )
                        }
                        fullWidth={false}
                        // width='20%'
                        // onClick={() => setIsOpenRegisterEmployeeDialog(true)}
                        // disabled={loaderStateApi}
                        // loaderState={loaderStateApi}
                        borderRadius="42px"
                        size="large"
                        background={theme.col_3_alpha}
                        backgroundRipple={theme.col_3_alpha}
                        focusColor={theme.col_1}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        typography={
                          <Typography
                            fontFamily={font.family.fm_2}
                            textTransform={"capitalize"}
                            fontSize={font.size.fs_4}
                            fontWeight="bold"
                            color={theme.col_3}
                            whiteSpace="nowrap"
                          >
                            Download Template
                          </Typography>
                        }
                      />
                      <ButtonCustom
                        // onClick={handleSignin}
                        fullWidth={false}
                        // width='20%'
                        onClick={() => setIsOpenRegisterEmployeeDialog(true)}
                        // disabled={loaderStateApi}
                        // loaderState={loaderStateApi}
                        borderRadius="42px"
                        size="large"
                        background={theme.col_3_alpha}
                        backgroundRipple={theme.col_3_alpha}
                        focusColor={theme.col_1}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        typography={
                          <Typography
                            fontFamily={font.family.fm_2}
                            textTransform={"capitalize"}
                            fontSize={font.size.fs_4}
                            fontWeight="bold"
                            color={theme.col_3}
                            whiteSpace="nowrap"
                          >
                            Add employee
                          </Typography>
                        }
                      />
                      <ButtonCustom
                        onClick={() =>
                          document.getElementById("inputClick").click()
                        }
                        fullWidth={false}
                        // width='23%'
                        // disabled={loaderStateApi}
                        // loaderState={loaderStateApi}
                        borderRadius="42px"
                        size="large"
                        background={theme.col_3_alpha}
                        backgroundRipple={theme.col_3_alpha}
                        focusColor={theme.col_1}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        typography={
                          <Typography
                            fontFamily={font.family.fm_2}
                            textTransform={"capitalize"}
                            fontSize={font.size.fs_4}
                            fontWeight="bold"
                            color={theme.col_3}
                            whiteSpace="nowrap"
                          >
                            Bulk Upload
                          </Typography>
                        }
                      />
                      <VisuallyHiddenInput
                        onChange={onFileSelect}
                        id="inputClick"
                        type="file"
                        accept=".csv"
                      />
                      <TooltipMA
                        title={
                          rowSelecter.length === 0 ? "No employee selected" : ""
                        }
                      >
                        <ButtonCustom
                          onClick={() => {
                            // setRevokeType("multiple");
                            setOpenRevokeConfirm(true);
                          }}
                          fullWidth={false}
                          // width='20%'
                          disabled={rowSelecter.length === 0}
                          // loaderState={loaderStateApi}
                          borderRadius="42px"
                          size="large"
                          background={theme.col_2_alpha}
                          backgroundRipple={theme.col_2_alpha}
                          focusColor={theme.col_1}
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          typography={
                            <Typography
                              fontFamily={font.family.fm_2}
                              textTransform={"capitalize"}
                              fontSize={font.size.fs_4}
                              fontWeight="bold"
                              color={theme.col_2}
                              whiteSpace="nowrap"
                            >
                              Remove Employee
                            </Typography>
                          }
                        />
                      </TooltipMA>
                    </Box>
                  )}
                </Box>
              </Box>

              {/* table */}
              <Box
                width="100%"
                display="flex"
                flexDirection="column"
                position="relative"
                // border="2px solid blue"
              >
                <TableVirtuoso
                  atBottomStateChange={(bottom) => {
                    console.log(bottom, "bottom");
                  }}
                  className="scroller"
                  ref={scrollerAll}
                  style={{ height: 470 }}
                  data={filteredList?.filter(
                    (empData, index) =>
                      empData.employeeId
                        ?.toLowerCase()
                        .includes(searchedEmpQuery?.toLowerCase()) ||
                      empData.name
                        ?.toLowerCase()
                        .includes(searchedEmpQuery?.toLowerCase()) ||
                      empData.email
                        ?.toLowerCase()
                        .includes(searchedEmpQuery?.toLowerCase()) ||
                      empData.designation
                        ?.toLowerCase()
                        .includes(searchedEmpQuery?.toLowerCase()) ||
                      empData.licenseType
                        ?.toLowerCase()
                        .includes(searchedEmpQuery?.toLowerCase()) ||
                      empData?.downloadedApplication ===
                        (searchedEmpQuery?.toLowerCase()?.includes("active")
                          ? true
                          : searchedEmpQuery
                              ?.toLowerCase()
                              ?.includes("inactive")
                          ? false
                          : "")
                  )}
                  components={TableComponents}
                  fixedHeaderContent={() => (
                    <TableRow
                      sx={{
                        background: theme.col_2_alpha2,
                        color: theme.col_2,
                      }}
                    >
                      {header === "Employees" || admin ? (
                        <></>
                      ) : (
                        <TableCell padding="checkbox">
                          <CheckboxMA
                            indeterminate={
                              rowSelecter.length > 0 &&
                              rowSelecter.length < filteredList.length
                                ? true
                                : false
                            }
                            checked={rowSelecter.length === 0 ? false : true}
                            onClick={() => {
                              setCurrentRowIndex(null);
                              rowSelecter.length === 0
                                ? setRowSelector([...filteredList])
                                : setRowSelector([]);
                            }}
                          />
                        </TableCell>
                      )}

                      {/* <TableCell>Employee Id</TableCell> */}
                      <TableCell
                        sx={{
                          color: theme.col_2,
                          fontWeight: "bold",
                          fontFamily: font.family.fm_2,
                          whiteSpace: "nowrap",
                        }}
                      >
                        First Name
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme.col_2,
                          fontWeight: "bold",
                          fontFamily: font.family.fm_2,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Last Name
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme.col_2,
                          fontWeight: "bold",
                          fontFamily: font.family.fm_2,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Email
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme.col_2,
                          fontWeight: "bold",
                          fontFamily: font.family.fm_2,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Designation
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme.col_2,
                          fontWeight: "bold",
                          fontFamily: font.family.fm_2,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Department
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme.col_2,
                          fontWeight: "bold",
                          fontFamily: font.family.fm_2,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Valid Up To
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme.col_2,
                          fontWeight: "bold",
                          fontFamily: font.family.fm_2,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Licence Type
                      </TableCell>
                      {/* <TableCell
                        sx={{
                          color: theme.col_2,
                          fontWeight: "bold",
                          fontFamily: font.family.fm_2,
                        }}
                      >
                        Details
                      </TableCell> */}
                      <TableCell
                        sx={{
                          width: "255px",
                          minWidth: "255px",
                          color: theme.col_2,
                          fontWeight: "bold",
                          fontFamily: font.family.fm_2,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Licence Status
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme.col_2,
                          fontWeight: "bold",
                          fontFamily: font.family.fm_2,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Invite Date
                      </TableCell>
                      {admin || header === "Employees" ? (
                        <></>
                      ) : (
                        <TableCell
                          sx={{
                            color: theme.col_2,
                            fontWeight: "bold",
                            fontFamily: font.family.fm_2,
                            whiteSpace: "nowrap",
                          }}
                        >
                          Resend invite
                        </TableCell>
                      )}
                    </TableRow>
                  )}
                  itemContent={(index, user, dd) => {
                    // result.push(...Array.of(user));
                    return (
                      <>
                        <EmployeeDataTableRow
                          // index={index}
                          admin={admin}
                          filteredList={filteredList}
                          scrollerTrigger={scrollerTrigger}
                          data={user}
                          header={header}
                          setOpenRevokeConfirm={setOpenRevokeConfirm}
                          openRevokeConfirm={openRevokeConfirm}
                          i={index}
                          rowSelecter={rowSelecter}
                          registerDetails={registerDetails}
                          rowSelecterDeallocated={rowSelecterDeallocated}
                          setRegisterDetails={setRegisterDetails}
                          setRowSelector={setRowSelector}
                          setRowSelectorDeallocated={setRowSelectorDeallocated}
                          employeesList={employeesList}
                          setEmployeesList={setEmployeesList}
                          currentRowIndex={currentRowIndex}
                          setCurrentRowIndex={setCurrentRowIndex}
                          fetchDataArrayLength={fetchDataArrayLength}
                          newEditRowIndex={newEditRowIndex}
                          setNewEditRowIndex={setNewEditRowIndex}
                          setIsOpenEditEmployeeDialog={
                            setIsOpenEditEmployeeDialog
                          }
                          isShowMoreIndex={isShowMoreIndex}
                          setIsShowMoreIndex={setIsShowMoreIndex}
                          isOpenDeleteEmployeeDialog={
                            isOpenDeleteEmployeeDialog
                          }
                          setIsOpenDeleteEmployeeDialog={
                            setIsOpenDeleteEmployeeDialog
                          }
                          currentCheckBoxOption={currentCheckBoxOption}
                          setCurrentCheckBoxOption={setCurrentCheckBoxOption}
                          checkboxOption={checkboxOption}
                          handleRevokeEmployee={handleRevokeEmployee}
                          handleUnRevokeEmployee={handleUnRevokeEmployee}
                          licenceBatchList={licenceBatchList}
                          scrollerDemo={scrollerDemo}
                          handleInvite={handleInvite}
                          inviteLoader={inviteLoader}
                          setAncher={setAncher}
                          ancher={ancher}
                        />
                      </>
                    );
                  }}
                />

                {filteredList?.length === 0 || result?.length === 0 ? (
                  <Box
                    display="flex"
                    width="100%"
                    alignItems="center"
                    justifyContent="center"
                    height="100%"
                    flexDirection="column"
                    position="absolute"
                    flex="1"
                  >
                    <Box
                      display="flex"
                      // width="20%"
                      px={3}
                      backgroundColor={theme.col_2_alpha}
                      height="80px"
                      borderRadius="13px"
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Typography
                        fontFamily={font.family.fm_2}
                        color={theme.col_2}
                        textAlign="center"
                        fontSize={font.size.fs_5}
                        fontWeight="bold"
                      >
                        No employee found
                      </Typography>
                    </Box>
                  </Box>
                ) : (
                  ""
                )}
                {/* <TableContainer
                id="scroller"
                  sx={{
                    maxHeight: 466,
                    minHeight: 466,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Table className="tableEmployees" size="small" stickyHeader>
                    <TableHead sx={{ height: "52px" }}>
                      {header === "Employees" ? (
                        <></>
                      ) : (
                        <TableCell padding="checkbox">
                          {" "}
                          <CheckboxMA
                            indeterminate={
                              rowSelecter.length > 0 &&
                              rowSelecter.length < filteredList.length
                                ? true
                                : false
                            }
                            checked={rowSelecter.length === 0 ? false : true}
                            onClick={() => {
                              setCurrentRowIndex(null);
                              rowSelecter.length === 0
                                ? setRowSelector([...filteredList])
                                : setRowSelector([]);
                            }}
                          />
                        </TableCell>
                      )}

            
                      <TableCell>Employee Name</TableCell>
                      <TableCell>Employee Email</TableCell>
                      <TableCell>Employee Designation</TableCell>
                      <TableCell>Licence Type</TableCell>
                      <TableCell sx={{ width: "231px", minWidth: "231px" }}>
                        Licence Status
                      </TableCell>
                     
                    </TableHead>
                    <TableBody>
                    

                      {filteredList
                        ?.filter(
                          (empData, index) =>
                          
                            empData.employeeId
                              ?.toLowerCase()
                              .includes(searchedEmpQuery?.toLowerCase()) ||
                            empData.name
                              ?.toLowerCase()
                              .includes(searchedEmpQuery?.toLowerCase()) ||
                            empData.email
                              ?.toLowerCase()
                              .includes(searchedEmpQuery?.toLowerCase()) ||
                            empData.designation
                              ?.toLowerCase()
                              .includes(searchedEmpQuery?.toLowerCase()) ||
                            empData.licenseType
                              ?.toLowerCase()
                              .includes(searchedEmpQuery?.toLowerCase())
                        )
                        ?.map((data, i, finalResult) => {
                          result.push(finalResult);
                          return (
                            <>
                              <EmployeeDataTableRow
                                index={index}
                                data={data}
                                header={header}
                                setOpenRevokeConfirm={setOpenRevokeConfirm}
                                openRevokeConfirm={openRevokeConfirm}
                                i={i}
                                rowSelecter={rowSelecter}
                                registerDetails={registerDetails}
                                rowSelecterDeallocated={rowSelecterDeallocated}
                                setRegisterDetails={setRegisterDetails}
                                setRowSelector={setRowSelector}
                                setRowSelectorDeallocated={
                                  setRowSelectorDeallocated
                                }
                                employeesList={employeesList}
                                setEmployeesList={setEmployeesList}
                                currentRowIndex={currentRowIndex}
                                setCurrentRowIndex={setCurrentRowIndex}
                                fetchDataArrayLength={fetchDataArrayLength}
                                newEditRowIndex={newEditRowIndex}
                                setNewEditRowIndex={setNewEditRowIndex}
                                setIsOpenEditEmployeeDialog={
                                  setIsOpenEditEmployeeDialog
                                }
                                isShowMoreIndex={isShowMoreIndex}
                                setIsShowMoreIndex={setIsShowMoreIndex}
                                isOpenDeleteEmployeeDialog={
                                  isOpenDeleteEmployeeDialog
                                }
                                setIsOpenDeleteEmployeeDialog={
                                  setIsOpenDeleteEmployeeDialog
                                }
                                currentCheckBoxOption={currentCheckBoxOption}
                                setCurrentCheckBoxOption={
                                  setCurrentCheckBoxOption
                                }
                                checkboxOption={checkboxOption}
                                handleRevokeEmployee={handleRevokeEmployee}
                                handleUnRevokeEmployee={handleUnRevokeEmployee}
                                licenceBatchList={licenceBatchList}
                                scrollerDemo={scrollerDemo}
                              />
                            </>
                          );
                        })}
                    </TableBody>
                  </Table>
                  {filteredList?.length === 0 || result?.length === 0 ? (
                    <Box
                      display="flex"
                      width="100%"
                      alignItems="center"
                      justifyContent="center"
                      height="100%"
                      flexDirection="column"
                      flex="1"
                    >
                      <Box
                        display="flex"
                        width="20%"
                        backgroundColor={theme.col_2_alpha}
                        height="80px"
                        borderRadius="13px"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Typography
                          fontFamily={font.family.fm_2}
                          color={theme.col_2}
                          textAlign="center"
                          fontSize={font.size.fs_5}
                          fontWeight="bold"
                        >
                          No employee found
                        </Typography>
                      </Box>
                    </Box>
                  ) : (
                    ""
                  )}
                </TableContainer> */}
              </Box>
            </Box>
          </>
        ) : (
          <ProfileTabs
            setReloadEmployees={setReloadEmployees}
            loaderState={loaderState}
            revokedEmployeesData={revokedEmployeesData}
            // employeesData={employeesData}
            profileQuery={profileQuery}
            tabs={tabs}
          />
        )}
      </Box>
      {/* <RegisterEmployeeDialog/> */}

      <GlobalSnackBar
        open={onBoardSnack}
        title={error}
        close={setOnBoardSnack}
      />

      {/* dialog */}
      {isOpenRegisterEmployeeDialog && (
        <RegisterEmployeeDialog
          setScrollerTrigger={setScrollerTrigger}
          scrollerAll={scrollerAll}
          scrollerStandard={scrollerStandard}
          onBoardSnack={onBoardSnack}
          setOnBoardSnack={setOnBoardSnack}
          error={error}
          setError={setError}
        />
      )}
      {isOpenEditEmployeeDialog && (
        <UpdateEmployeeDialog
          onBoardSnack={onBoardSnack}
          setOnBoardSnack={setOnBoardSnack}
          error={error}
          setError={setError}
        />
      )}
      {isOpenDeleteEmployeeDialog && <DeleteEmployeeDialog />}
      {isOpenUploadEmployeeDialog && <UploadEmployeeDialog />}
      <RevokeConfirmation
        rowSelecter={rowSelecter}
        handleRevokeEmployee={handleRevokeEmployee}
        setOpenRevokeConfirm={setOpenRevokeConfirm}
        openRevokeConfirm={openRevokeConfirm}
      />
      <UploadConfirmation
        uploadProgress={uploadProgress}
        uploadLength={uploadLength}
        setTouchUpload={setTouchUpload}
        licenceCount={
          header === "Trial" ? demoLicenceCount : standardLicenceCount
        }
        limit={{ totalLicence, allocatedLicence }}
        uploadDoc={uploadDoc}
        csvFile={csvFile}
        openUploadConfirm={openUploadConfirm}
        setOpenUploadConfirm={setOpenUploadConfirm}
      />
      <UploadProgress
        uploadProgress={uploadProgress}
        uploadLength={uploadLength}
        setTouchUpload={setTouchUpload}
        licenceCount={
          header === "Trial" ? demoLicenceCount : standardLicenceCount
        }
        limit={{ totalLicence, allocatedLicence }}
        uploadDoc={uploadDoc}
        csvFile={csvFile}
        openUploadConfirm={openUploadConfirm}
        setOpenUploadConfirm={setOpenUploadConfirm}
      />
    </>
  );
};
const TableComponents = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props) => <Table {...props} style={{ borderCollapse: "separate" }} />,
  TableHead: TableHead,
  TableRow: (props) => <TableRow className="row" {...props} />,
  TableBody: React.forwardRef((props, ref) => (
    <TableBody {...props} ref={ref} />
  )),
};

const EmployeeDataTableRow = ({
  data,
  i,
  setOpenRevokeConfirm,
  rowSelecter,
  registerDetails,
  setRegisterDetails,
  setRowSelector,
  employeesList,
  setEmployeesList,
  currentRowIndex,
  setCurrentRowIndex,
  header,
  setIsOpenEditEmployeeDialog,
  licenceBatchList,
  scrollerTrigger,
  filteredList,
  handleInvite,
  inviteLoader,
  setAncher,
  ancher,
  admin,
}) => {
  // console.log(data, "data", i, "i", rowSelecter, "rowSelector", registerDetails, "registerDetails", setRowSelector, "setRowSelector", employeesList, "employeesList",)

  // states
  // const [isShowMore, setIsShowMore] = useState(false);
  // console.log

  return (
    <>
      {header === "Employees" || admin ? (
        <></>
      ) : (
        <TableCell
          size="small"
          padding="checkbox"
          align="center"
          style={{ minWidth: "10px", maxWidth: "10px" }}
          sx={{
            height: "52px",
            backgroundColor:
              currentRowIndex === i
                ? theme.col_1
                : rowSelecter.includes(data)
                ? theme.col_3_alpha
                : scrollerTrigger && i === filteredList?.length - 1
                ? theme.col_14_alpha
                : theme.col_4,

            // backgroundColor: rowSelecter.includes(data)
            //   ? theme.col_3_alpha
            //   : theme.col_4,
          }}
          onClick={() =>
            rowSelecter?.length !== 0 ? "" : setCurrentRowIndex(i)
          }
        >
          {/* <CheckboxMA checked={rowSelecter.includes(data) || i < fetchDataArrayLength ? true : false} /> */}
          <CheckboxMA
            checked={rowSelecter.includes(data) ? true : false}
            onClick={() => {
              !rowSelecter.includes(data)
                ? rowSelecter.push(data)
                : rowSelecter.splice(rowSelecter.indexOf(data), 1);

              setRowSelector([...rowSelecter]);
              setTimeout(() => {
                setCurrentRowIndex(null);
              }, 200);
            }}
            // disabled={
            //   currentCheckBoxOption === checkboxOption.allocate &&
            //   data.downloadedApplication === true
            //     ? true
            //     : currentCheckBoxOption === checkboxOption.unallocate &&
            //       data.downloadedApplication === false
            //     ? true
            //     : false
            // }
          />
        </TableCell>
      )}

      {/* <TableCell
          size="small"
          colSpan="1"
          align="left"
          style={{ minWidth: "80px", maxWidth: "80px" }}
        >
          {" "}
          {currentRowIndex === i ? (
            <TextFieldMA
              id="emp"
              defaultValue={data.epId}
              // disabled={data.licenseStatus === "allocated"}
              disabled={currentRowIndex !== i}
              error={
                rowSelecter.includes(data)
                  ? registerDetails.epId === null
                    ? false
                    : registerDetails.epId === ""
                    ? true
                    : false
                  : false
              }
              helperText={
                rowSelecter.includes(data)
                  ? registerDetails.epId === null
                    ? ""
                    : registerDetails.epId === ""
                    ? "Employee Id is required"
                    : ""
                  : ""
              }
              onBlur={(e) => (data.epId = e.target.value)}
              size="small"
              fullWidth
              placeholder="Employee Id"
            />
          ) : (
            <Box sx={{ maxWidth: "100%" }}>
              <Typography maxWidth="100%" noWrap="wrap">
                {data.employeeId}
              </Typography>
            </Box>
          )}
        </TableCell> */}

      <TableCell
        size="small"
        colSpan="1"
        align="left"
        style={{ minWidth: "150px", maxWidth: "150px" }}
        className={
          header === "Employees" || rowSelecter?.length !== 0
            ? "none"
            : "row" || admin
        }
        sx={{
          height: "52px",
          backgroundColor:
            currentRowIndex === i
              ? theme.col_1
              : rowSelecter.includes(data)
              ? theme.col_3_alpha
              : scrollerTrigger && i === filteredList?.length - 1
              ? theme.col_14_alpha
              : theme.col_4,

          // backgroundColor: rowSelecter.includes(data)
          //   ? theme.col_3_alpha
          //   : theme.col_4,
        }}
        onClick={() => (rowSelecter?.length !== 0 ? "" : setCurrentRowIndex(i))}
      >
        <Box sx={{ maxWidth: "100%" }}>
          <Typography display="flex" alignItems="center" gap="9px">
            {/* <Avatar {...stringAvatar(data.name)} />
             */}
            <Box
              display="flex"
              alignItems="center"
              width="40px"
              minWidth="40px"
              height="40px"
              borderRadius="50px"
              flexDirection="column"
              justifyContent="center"
              backgroundColor={theme.col_14_alpha}
            >
              <Typography
                fontFamily={font.family.fm_2}
                fontSize={font.size.fs_3}
                fontWeight="bold"
                color={theme.col_3}
                textTransform="capitalize"
              >
                {stringToArray(data.name)}
              </Typography>
            </Box>
            <Tooltip
              title={
                <Box display="flex" flexDirection="column" gap="6px">
                  <Typography
                    textTransform="capitalize"
                    fontSize={font.size.fs_3}
                  >
                    First Name: {data?.name}
                  </Typography>
                </Box>
              }
            >
              <Typography
                textTransform="capitalize"
                maxWidth="100%"
                noWrap="wrap"
                sx={{ cursor: "pointer" }}
              >
                {data?.name}
              </Typography>
            </Tooltip>
          </Typography>
        </Box>
      </TableCell>
      <TableCell
        size="small"
        colSpan="1"
        align="left"
        style={{ minWidth: "150px", maxWidth: "150px" }}
        className={
          header === "Employees" || rowSelecter?.length !== 0
            ? "none"
            : "row" || admin
        }
        sx={{
          height: "52px",
          backgroundColor:
            currentRowIndex === i
              ? theme.col_1
              : rowSelecter.includes(data)
              ? theme.col_3_alpha
              : scrollerTrigger && i === filteredList?.length - 1
              ? theme.col_14_alpha
              : theme.col_4,

          // backgroundColor: rowSelecter.includes(data)
          //   ? theme.col_3_alpha
          //   : theme.col_4,
        }}
        onClick={() => (rowSelecter?.length !== 0 ? "" : setCurrentRowIndex(i))}
      >
        <Box sx={{ maxWidth: "100%" }}>
          <Typography display="flex" alignItems="center" gap="9px">
            {/* <Avatar {...stringAvatar(data.name)} />
             */}

            <Tooltip
              title={
                <Box display="flex" flexDirection="column" gap="6px">
                  <Typography
                    textTransform="capitalize"
                    fontSize={font.size.fs_3}
                  >
                    Last Name: {data?.lastName}
                  </Typography>
                </Box>
              }
            >
              <Typography
                textTransform="capitalize"
                maxWidth="100%"
                noWrap="wrap"
                sx={{ cursor: "pointer" }}
              >
                {data?.lastName}
              </Typography>
            </Tooltip>
          </Typography>
        </Box>
      </TableCell>
      <TableCell
        size="small"
        colSpan="1"
        align="left"
        style={{ minWidth: "240px", maxWidth: "240px" }}
        className={
          header === "Employees" || rowSelecter?.length !== 0
            ? "none"
            : "row" || admin
        }
        sx={{
          height: "52px",
          backgroundColor:
            currentRowIndex === i
              ? theme.col_1
              : rowSelecter.includes(data)
              ? theme.col_3_alpha
              : scrollerTrigger && i === filteredList?.length - 1
              ? theme.col_14_alpha
              : theme.col_4,

          // backgroundColor: rowSelecter.includes(data)
          //   ? theme.col_3_alpha
          //   : theme.col_4,
        }}
        onClick={() => (rowSelecter?.length !== 0 ? "" : setCurrentRowIndex(i))}
      >
        <Box sx={{ maxWidth: "100%" }}>
          <Tooltip
            title={
              <Box display="flex" flexDirection="column" gap="6px">
                <Typography fontSize={font.size.fs_3}>
                  Employee Email: {data?.email}
                </Typography>
              </Box>
            }
          >
            <Typography
              maxWidth="100%"
              noWrap="wrap"
              sx={{ cursor: "pointer" }}
            >
              {data.email}
            </Typography>
          </Tooltip>
        </Box>
      </TableCell>
      <TableCell
        size="small"
        colSpan="1"
        align="left"
        style={{ minWidth: "150px", maxWidth: "150px" }}
        className={
          header === "Employees" || rowSelecter?.length !== 0
            ? "none"
            : "row" || admin
        }
        sx={{
          height: "52px",
          backgroundColor:
            currentRowIndex === i
              ? theme.col_1
              : rowSelecter.includes(data)
              ? theme.col_3_alpha
              : scrollerTrigger && i === filteredList?.length - 1
              ? theme.col_14_alpha
              : theme.col_4,

          // backgroundColor: rowSelecter.includes(data)
          //   ? theme.col_3_alpha
          //   : theme.col_4,
        }}
        onClick={() => (rowSelecter?.length !== 0 ? "" : setCurrentRowIndex(i))}
      >
        <Box sx={{ maxWidth: "100%" }}>
          <Typography maxWidth="100%" noWrap="wrap">
            {data.designation}
          </Typography>
        </Box>
      </TableCell>

      <TableCell
        size="small"
        colSpan="1"
        align="left"
        style={{ minWidth: "150px", maxWidth: "150px" }}
        className={
          header === "Employees" || rowSelecter?.length !== 0
            ? "none"
            : "row" || admin
        }
        sx={{
          height: "52px",
          backgroundColor:
            currentRowIndex === i
              ? theme.col_1
              : rowSelecter.includes(data)
              ? theme.col_3_alpha
              : scrollerTrigger && i === filteredList?.length - 1
              ? theme.col_14_alpha
              : theme.col_4,

          // backgroundColor: rowSelecter.includes(data)
          //   ? theme.col_3_alpha
          //   : theme.col_4,
        }}
        onClick={() => (rowSelecter?.length !== 0 ? "" : setCurrentRowIndex(i))}
      >
        <Box sx={{ maxWidth: "100%" }}>
          <Typography maxWidth="100%" noWrap="wrap">
            {data?.department}
          </Typography>
        </Box>
      </TableCell>
      <TableCell
        sx={{
          backgroundColor:
            currentRowIndex === i
              ? theme.col_1
              : rowSelecter.includes(data)
              ? theme.col_3_alpha
              : scrollerTrigger && i === filteredList?.length - 1
              ? theme.col_14_alpha
              : theme.col_4,
          whiteSpace: "nowrap",
        }}
      >
        {dayjs(
          data.licenseType === "Trial"
            ? licenceBatchList[0]?.expirationDate
            : licenceBatchList[1]?.expirationDate
        ).format("DD MMMM YYYY")}
      </TableCell>
      <TableCell
        size="small"
        colSpan="1"
        align="left"
        style={{ minWidth: "150px", maxWidth: "150px" }}
        className={
          header === "Employees" || rowSelecter?.length !== 0
            ? "none"
            : "row" || admin
        }
        sx={{
          height: "52px",
          backgroundColor:
            currentRowIndex === i
              ? theme.col_1
              : rowSelecter.includes(data)
              ? theme.col_3_alpha
              : scrollerTrigger && i === filteredList?.length - 1
              ? theme.col_14_alpha
              : theme.col_4,

          // backgroundColor: rowSelecter.includes(data)
          //   ? theme.col_3_alpha
          //   : theme.col_4,
        }}
        onClick={() => (rowSelecter?.length !== 0 ? "" : setCurrentRowIndex(i))}
      >
        <Tooltip
          title={
            <Box width="250px" display="flex" flexDirection="column" gap="6px">
              <Typography
                fontWeight="bold"
                fontSize={font.size.fs_3}
                textTransform="capitalize"
              >
                Licence Type : {data.licenseType}
              </Typography>
              <Typography fontWeight="bold" fontSize={font.size.fs_3}>
                Purchased on :{" "}
                {dayjs(
                  data.licenseType === "Trial"
                    ? licenceBatchList[0]?.purchaseDate
                    : licenceBatchList[1]?.purchaseDate
                ).format("DD MMMM YYYY")}
              </Typography>
              <Typography fontWeight="bold" fontSize={font.size.fs_3}>
                Valid up to :{" "}
                {dayjs(
                  data.licenseType === "Trial"
                    ? licenceBatchList[0]?.expirationDate
                    : licenceBatchList[1]?.expirationDate
                ).format("DD MMMM YYYY")}
              </Typography>
            </Box>
          }
        >
          <Typography
            // width="fit-content"
            // padding={"2px 8px"}
            width="93px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="25px"
            textTransform="capitalize"
            borderRadius="25px"
            color={theme.col_3}
            fontWeight="bold"
            backgroundColor={theme.col_14_alpha}
            fontSize={font.size.fs_4}
            sx={{
              cursor: "pointer",
              "&:hover": { boxShadow: "0px 0px 6px -1px" },
            }}
          >
            {data.licenseType}
          </Typography>
        </Tooltip>
      </TableCell>

      {/* <TableCell
        size="small"
        align="left"
        className={
          header === "Employees" || rowSelecter?.length !== 0 ? "none" : "row"
        }
        sx={{
          height: "52px",
          backgroundColor:
            currentRowIndex === i
              ? theme.col_1
              : rowSelecter.includes(data)
              ? theme.col_3_alpha
              : scrollerTrigger && i === filteredList?.length - 1
              ? theme.col_14_alpha
              : theme.col_4,
        }}
        onClick={() => (rowSelecter?.length !== 0 ? "" : setCurrentRowIndex(i))}
      >
        <Tooltip
          title={
            <Box  display="flex" flexDirection="column" gap="6px">
              <Typography
                fontWeight="bold"
                fontSize={font.size.fs_4}
                textTransform="capitalize"
              >
              Details
              </Typography>
            </Box>
          }
        >
          <InfoIcon
            onClick={(e) => setAncher(e.currentTarget)}
            sx={{ color: theme.col_2, fontSize: font.size.fs_2 }}
          />
        </Tooltip>
      </TableCell> */}
      <TableCell
        size="small"
        // colSpan="2"
        align="center"
        sx={{
          height: "52px",
          backgroundColor:
            currentRowIndex === i
              ? theme.col_1
              : rowSelecter.includes(data)
              ? theme.col_3_alpha
              : scrollerTrigger && i === filteredList?.length - 1
              ? theme.col_14_alpha
              : theme.col_4,

          // backgroundColor: rowSelecter.includes(data)
          //   ? theme.col_3_alpha
          //   : theme.col_4,
        }}
        onClick={() => (rowSelecter?.length !== 0 ? "" : setCurrentRowIndex(i))}
      >
        <Box
          className={
            rowSelecter.length !== 0 || header === "Employees" || admin
              ? "none"
              : "detail"
          }
          sx={{ display: "flex", alignItems: "center", gap: "20px" }}
        >
          {/* {data.licenseStatus === "allocated" ?
                  <Box display="flex" alignItems="center" gap={1} color={grey[600]} fontWeight="bold" py={0.2} px={1} >  <Box style={{ width: "10px", height: "10px", borderRadius: "50%", background: green[600] }}></Box> Allocated</Box>
                  :
                  <Box display="flex" alignItems="center" gap={1} color={grey[600]} fontWeight="bold" py={0.2} px={1} >  <Box style={{ width: "10px", height: "10px", borderRadius: "50%", background: red[600] }}></Box> Unallocated</Box>
                } */}
          <OrganisationBadge status={data.downloadedApplication} />
          {/* <MoreVertIcon sx={{background:theme.col_14_alpha,borderRadius:'40px',color:theme.col_3,fontSize:'28px'}}/> */}
          {/* <StatusBadge status={data.licenseStatus} /> */}
        </Box>
        <Typography
          display="none"
          className={
            rowSelecter.length !== 0 || header === "Employees" || admin
              ? "none"
              : "display"
          }
          alignItems="center"
          gap="10px"
        >
          <ButtonCustom
            // onClick={handleSignin}
            fullWidth={true}
            // width='20%'
            onClick={() => {
              setRegisterDetails(data);
              setIsOpenEditEmployeeDialog(true);
            }}
            // disabled={loaderStateApi}
            // loaderState={loaderStateApi}
            borderRadius="42px"
            size="large"
            background={theme.col_3_alpha}
            backgroundRipple={theme.col_3_alpha}
            focusColor={theme.col_1}
            display="flex"
            alignItems="center"
            justifyContent="center"
            typography={
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_4}
                fontWeight="bold"
                color={theme.col_3}
              >
                Update
              </Typography>
            }
          />
          <ButtonCustom
            // onClick={handleSignin}
            fullWidth={true}
            // width='20%'
            // onClick={() => setIsOpenRegisterEmployeeDialog(true)}
            onClick={() => {
              setRegisterDetails(data);
              setOpenRevokeConfirm(true);
            }}
            // disabled={loaderStateApi}
            // loaderState={loaderStateApi}
            borderRadius="42px"
            size="large"
            background={theme.col_2_alpha}
            backgroundRipple={theme.col_2_alpha}
            focusColor={theme.col_1}
            display="flex"
            alignItems="center"
            justifyContent="center"
            typography={
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_4}
                fontWeight="bold"
                color={theme.col_2}
              >
                Remove
              </Typography>
            }
          />
        </Typography>
      </TableCell>
      <TableCell sx={{ whiteSpace: "nowrap" }}>
        {dayjs(data?.createdAt).format("DD MMMM YYYY")}
      </TableCell>
      {admin || header === "Employees" ? (
        <></>
      ) : (
        <TableCell>
          <ButtonCustom
            onClick={() => handleInvite(data)}
            fullWidth={true}
            // width='20%'
            // onClick={() => setIsOpenRegisterEmployeeDialog(true)}
            // onClick={() => {
            //   setRegisterDetails(data);
            //   setOpenRevokeConfirm(true);
            // }}
            disabled={
              inviteLoader ||
              dayjs().isAfter(
                data.licenseType === "Trial"
                  ? licenceBatchList[0]?.expirationDate
                  : licenceBatchList[1]?.expirationDate
              )
            }
            loaderState={inviteLoader}
            borderRadius="42px"
            size="large"
            background={theme.col_3_alpha}
            backgroundRipple={theme.col_3_alpha}
            focusColor={theme.col_1}
            display="flex"
            alignItems="center"
            justifyContent="center"
            typography={
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_4}
                fontWeight="bold"
                color={theme.col_3}
                noWrap
              >
                Resend
              </Typography>
            }
          />
        </TableCell>
      )}
      <Menu
        anchorOrigin={{ vertical: "bottom", horizontal: -100 }}
        anchorReference="anchorEl"
        sx={{
          ".MuiMenu-paper": {
            boxShadow: "0px 1px 4px -2px grey",
            borderRadius: "8px",
          },
        }}
        open={Boolean(ancher)}
        onClose={() => setAncher(null)}
        anchorEl={ancher}
      >
        <Box display="flex" flexDirection="column" p={1} gap="7px">
          <Box display="flex" alignItems="center" gap="4px">
            <FieldHeading>Designation</FieldHeading>
            <FieldValue>{data.designation}</FieldValue>
          </Box>
          <Box display="flex" alignItems="center" gap="4px">
            <FieldHeading>Department</FieldHeading>
            <FieldValue>{data.department}</FieldValue>
          </Box>
          <Box display="flex" alignItems="center" gap="4px">
            <FieldHeading>Valid Up To</FieldHeading>
            <FieldValue>
              {dayjs(
                data.licenseType === "Trial"
                  ? licenceBatchList[0]?.expirationDate
                  : licenceBatchList[1]?.expirationDate
              ).format("DD MMMM YYYY")}
            </FieldValue>
          </Box>
        </Box>
      </Menu>
      {/* <TableCell  colSpan={2} className='display' sx={{display:'none'}} >
              
              </TableCell> */}

      {/* <TableCell
            size="small"
            align="center"
            colSpan='2'
            className="detail"
          >
            <Box sx={{ display:'flex',alignItems:'center',gap:'20px',justifyContent:'center' }}>
              <MoreVertIcon  onClick={() =>
          rowSelecter.length === 0 && header !== "Employees"
            ? setCurrentRowIndex(i)
            : ""
        } sx={{background:theme.col_14_alpha,borderRadius:'40px',color:theme.col_3,fontSize:'28px',cursor:'pointer'}}/>

            </Box>
          </TableCell> */}
      {/* <TableCell
          size="small"
          onBlur={() => setIsShowMoreIndex(null)}
          align="center"
          style={{ position: "relative", minWidth: "80px", maxWidth: "80px" }}
        >

          {isShowMoreIndex !== i ? (
            <>
              <TooltipMA title="More">
                <IconButtonMA
                  size="small"
                  onClick={() => handleClickMore(i)}
                  sx={{ background: theme.grey[200] }}
                >
                  <MoreVert sx={{ fontSize: "20px !important" }} />
                </IconButtonMA>
              </TooltipMA>
            </>
          ) : (
            <Box
              display={"flex"}
              alignItems="center"
              gap={2}
              borderRadius="40px"
              bgcolor={grey[100]}
              p={0.4}
              sx={{
                position: "absolute",
                top: "50%",
                right: "30.2%",
                transform: "translate(0%, -50%)",
              }}
            >
              {currentRowIndex !== i && (
                <TooltipMA title="Edit">
                  <IconButtonMA
                    onClick={() => handleClickEdit(i)}
                    size="small"
                    sx={{ background: theme.grey[200] }}
                  >
                    <EditIcon sx={{ fontSize: "20px !important" }} />
                  </IconButtonMA>
                </TooltipMA>
              )}


              {currentRowIndex === i && (
                <TooltipMA title="Save">
                  <IconButtonMA
                    onClick={() => handleClickSave(i)}
                    size="small"
                    sx={{ background: theme.grey[200] }}
                  >
                    <DoneIcon sx={{ fontSize: "20px !important" }} />
                  </IconButtonMA>
                </TooltipMA>
              )}

        

              {currentRowIndex !== i && data.downloadedApplication === true && (
                <TooltipMA title="Deallocated Employee">
                  <IconButtonMA
                    size="small"
                    onClick={() => handleDeallocateEmployee(data)}
                    sx={{ background: theme.grey[200] }}
                  >
                    <PersonOffIcon sx={{ fontSize: "20px !important" }} />
                  </IconButtonMA>
                </TooltipMA>
              )}

              {currentRowIndex !== i && data.downloadedApplication === false && (
                <TooltipMA title="Allocated Employee">
                  <IconButtonMA
                    size="small"
                    onClick={() => handleAllocateEmployee(data)}
                    sx={{ background: theme.grey[200] }}
                  >
                    <PersonAddAltIcon sx={{ fontSize: "20px !important" }} />
                  </IconButtonMA>
                </TooltipMA>
              )}

              <TooltipMA title="Close">
                <IconButtonMA
                  onClick={() => setIsShowMoreIndex(null)}
                  size="small"
                  sx={{ background: theme.grey[200] }}
                >
                  <CloseIcon sx={{ fontSize: "20px !important" }} />
                </IconButtonMA>
              </TooltipMA>
            </Box>
          )}

        </TableCell> */}
    </>
  );
};

const ProfileTabs = ({
  tabs,
  profileQuery,
  employeesData,
  loaderState,
  setReloadEmployees,
  revokedEmployeesData,
}) => {
  switch (tabs) {
    case 1:
      return (
        <RegisteredUsers
          setReloadEmployees={setReloadEmployees}
          loaderState={loaderState}
          employeesData={employeesData}
          profileQuery={profileQuery}
        />
      );
    case 2:
      return (
        <RevokedUsers
          setReloadEmployees={setReloadEmployees}
          loaderState={loaderState}
          employeesData={employeesData}
          profileQuery={profileQuery}
          revokedEmployeesData={revokedEmployeesData}
        />
      );
    default:
      return;
  }
};

// const StatusBadge = ({ status }) => {
//   if (status === "allocated") {
//     return (
//       <Box
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 2,
//           padding: "2px 8px",
//           borderRadius: "14px",
//           backgroundColor: theme.statusSuccessAlpha,
//         }}
//       >
//         <Box
//           height="8px"
//           width="8px"
//           borderRadius="50px"
//           bgColor={theme.statusSuccess}
//         ></Box>
//         <Typography
//           fontWeight="bold"
//           variant="caption"
//           color={theme.statusSuccess}
//         >
//           Allocated
//         </Typography>
//       </Box>
//     );
//   } else {
//     return (
//       <Box
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 2,
//           padding: "2px 8px",
//           borderRadius: "14px",
//           backgroundColor: theme.statusDisabledAlpha,
//         }}
//       >
//         <Box
//           height="8px"
//           width="8px"
//           borderRadius="50px"
//           bgColor={theme.statusDisabled}
//         ></Box>
//         <Typography
//           fontWeight="bold"
//           variant="caption"
//           color={theme.statusDisabled}
//         >
//           Unallocated
//         </Typography>
//       </Box>
//     );
//   }
// };
